<template>
  <div>
    <b-breadcrumb :items="breads"></b-breadcrumb>
    <b-container fluid class="pl-5 pr-5">
      <b-row class="offset-1 col-10">
        <b-col md="2" cols="12" class="border-right mh-600">
          <div class="px-3">
            <b-list-group flush>
              <b-list-group-item v-for="classify in classifies" :key="classify.id" v-bind="classify" class="rounded text-truncate">
                {{ classify.name }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-col>
        <b-col md="10" cols="12" class="px-3">
          <product-list-table :list="list" :page="page" :each="each" :total="total" :sort="sort" @page:change="onPageChange" @sort:change="onSortChange"></product-list-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import ProductListTable from './ProductListTable'
import { State } from '../library/EventBus.js'
import QueryString from 'querystring'
export default {
  components: {
    ProductListTable
  },
  data () {
    return {
      list: [],
      total: 0,
      page: 1,
      each: 10,
      sort: 'new',
      classifies: [],
      breads: []
    }
  },
  computed: {
    topId () {
      return this.$route.params.top
    },
    subId () {
      return this.$route.params.sub
    }
  },
  methods: {
    async start () {
      // classify content data
      const query = QueryString.stringify({
        page: this.page,
        each: this.each,
        sort: this.sort
      })
      const cid = (this.subId || this.topId)
      const { data: catalogs, headers } = await this.$api.getClassifyItem(cid, `?${query}`)
      this.list = catalogs
      this.total = Number.parseInt(headers['shop-option-total']) || 0
      this.page = Number.parseInt(headers['shop-option-page']) || 1
      this.each = Number.parseInt(headers['shop-option-each']) || 10
      this.sort = headers['shop-option-sort'] || ''
    },
    async fetchSubClassify () {
      let list = []
      try {
        const { data } = await this.$api.getClassifySub(this.topId)
        data.sort((a, b) => a.sort - b.sort)
        list = data.map(item => {
          const { id, name } = item
          return { id, name, to: `/classify/${this.topId}/${id}`, exact: false }
        })
      } catch (err) {
        console.log(err)
      }
      list.unshift({
        id: 'all',
        name: '所有商品',
        to: `/classify/${this.topId}`,
        exact: true
      })
      this.classifies = list
      // breadcrumb
      const breads = [{
        id: 'home',
        text: '首頁',
        to: '/'
      }]
      const findTop = State.topClassify.find(c => c.id === this.topId)
      if (findTop) {
        const { id, name: text, link: to } = findTop
        breads.push({ id, text, to })
      }
      if (this.subId) {
        const findSub = list.find(c => c.id === this.subId)
        if (findSub) {
          const { id, name: text, link: to } = findSub
          breads.push({ id, text, to })
        }
      }
      this.breads = breads
    },
    onPageChange (page = 1) {
      this.page = page
      this.init(this.$route)
    },
    onSortChange (sort = '') {
      this.sort = sort
      this.init(this.$route)
    },
    init () {
      this.fetchSubClassify()
      this.start()
    }
  },
  mounted () {
    this.init()
  },
  beforeRouteUpdate (to, from, next) {
    // react to route changes...
    // don't forget to call next()
    console.log('route update @ Classify.vue')
    this.page = 1
    this.each = 10
    this.sort = 'new'
    this.$nextTick(this.init)
    next()
  }
}
</script>
<style>
  @media (min-width: 576px)
  .mh-600 {
    min-height: 600px;
  }
  .breadcrumb {
	background: none;
    padding-left: 12.7%;
  }
  .list-group-item {
    background: #fefefe;
  }
  .list-group a.list-group-item {
    font-size: 1.1rem;
	border-width: 0;
	padding: .65rem 1.25rem;
  }
  @media (max-width: 1620px) {
  .breadcrumb {
    padding-left: 4.7%;
  }
  .offset-1 {
	margin-left: 0;
  }
  .col-10 {
	padding: 0;
	flex: unset;
    max-width: unset;
  }}
  @media (max-width: 992px) {
  div.pr-5.pl-5 {
	padding-left: 1rem!important;
  }}
</style>